import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgbcl-registration-failure-page',
  templateUrl: './registration-failure-page.component.html',
  styleUrls: ['./registration-failure-page.component.scss']
})
export class RegistrationFailurePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
